export default __webpack_public_path__ + "static/media/Deflationary.6cba5b8c.png";